/**
 * Player object
 */
var player = {

	params : {
		video:'',
		progressBar:'',
		button:'',
		buffer:'',
		playPause: '',
		muteSound: '',
		fullscreen: '',
		onloaded : function(){},
		onplay : function(){},
		onpaused : function(){}
	},

	init : function(options){
		this.params=$.extend(this.params,options);
		$(this.params.video).bind('timeupdate',this.updateProgress);
	},

	playPause : function () {
		var media=$(player.params.video)[0];
		$(player.params.button).removeClass('loading');
		if(media.paused){
			media.play();
			$(player.params.video).addClass('play');
			$(player.params.button).addClass('off');
			$(player.params.playPause).removeClass('pause');
			$(player.params.playPause).addClass('play');
			player.params.onplay.call(this);
		}
		else{
			media.pause();
			$(player.params.button).removeClass('off');
			$(player.params.playPause).removeClass('play');
			$(player.params.playPause).addClass('pause');
		}
	},

	updateProgress : function () {
		var media=$(this)[0];
		var progressW=media.currentTime*100/media.duration;
		$(player.params.progressBar).width(progressW+'%');

		var bufferW=media.buffered.end(0)*100/media.duration;
		$(player.params.buffer).width(bufferW+'%');
	},

	setTime : function (e) {
		var media=$(player.params.video)[0];
		media.currentTime=e.offsetX*media.duration/$(this).width();
	},

	updateSound : function() {
		var media = $(player.params.video)[0];
		if(media.muted){
			media.muted = false;
			$(player.params.muteSound).removeClass('mute');
			$(player.params.muteSound).addClass('sound');
		}
		else {
			media.muted = true;
			$(player.params.muteSound).removeClass('sound');
			$(player.params.muteSound).addClass('mute');
		}
	},

	updateFullscreen : function() {
		var media = $(player.params.video)[0];
		var isFullscreen= false;

		if(!isFullscreen){
        if (media.requestFullscreen) {
            media.requestFullscreen();
        }
        else if (media.mozRequestFullScreen) {
            container.mozRequestFullScreen(); // Firefox
        }
        else if (media.webkitRequestFullscreen) {
            media.webkitRequestFullscreen(); // Chrome and Safari
        }
        isFullscreen=true;
    }
    else{

        if(document.cancelFullScreen) {
            document.cancelFullScreen();
        }
        else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        }
        else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        }
        isFullscreen=false;
    }

	}
}
